import React from 'react';
import Login from '../components/LoginComponent/Login';

function LoginPage() {
  return (
    <div>
      <Login />
    </div>
  );
}

export default LoginPage;
